/** Functions */
import { BydIsHttpParam } from './byd-is-http-param.function';

/**
 * Generate new parameters it replaces the value for a parameter.
 *
 * @param filters the filters object
 * @returns BydHttpParams
 */
export function BydCleanParams<T>(filters: T): T {
  if (filters) {
    const httpParams = filters;
    for (let i = 0, keys = Object.keys(filters); i < keys.length; i++) {
      const key = keys[i];
      const value = filters[key];
      if (!BydIsHttpParam(value)) delete httpParams[keys[i]];
    }
    return httpParams;
  }
}
